export default "__VITE_ASSET__fb70307c__"